
export const avatarImage = function (entity) {
  if (!entity || !entity.image) {
    return false
  }
  return entity.image.find(e => e.type === 'avatar').location || ''
}

export const avatarLetters = function (entity) {
  if (!entity || !entity.name) {
    return ''
  }
  let initials = ''
  if (entity.name.First) {
    initials = entity.name.First.substring(0, 1)
  }
  if (entity.name.Last) {
    initials = initials.concat('', entity.name.Last.substring(0, 1))
  }

  return initials
}

export const displayName = function (entity) {
  if (!entity || !entity.name) {
    return ''
  }
  return entity.name.Label || `${entity.name.First} ${entity.name.Last}`
}

export const primaryContactEmail = function (entity) {
  if (!entity || !entity.contact) {
    return {}
  }
  const c = entity.contact.find(c => c.type === 'primary')
  return c.email[0].address || {}
}
